import React, { useState, useEffect } from "react";
import { Card, Modal, Spin, Row, Col } from "antd";
import { Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "./Impact.css";
import {
  SmileOutlined,
  HeartOutlined,
  CloudOutlined,
  TeamOutlined,
  RotateLeftOutlined,
} from "@ant-design/icons";

const powerBIUrls = {
  smartGirl: process.env.REACT_APP_IMPACT_SMART_GIRL,
  healthMission: process.env.REACT_APP_IMPACT_HEALTH,
  waterRejuvenation: process.env.REACT_APP_IMPACT_WATER,
  matrimony: process.env.REACT_APP_IMPACT_MATRIMONY,
};

const impactTitles = {
  smartGirl: "Smart Girl Impact Report",
  healthMission: "Health & Disaster Relief Report",
  waterRejuvenation: "Water Rejuvenation Report",
  matrimony: "Matrimony Report",
};

function isMobilePortrait() {
  return window.innerHeight > window.innerWidth && window.innerWidth < 768;
}

const ImpactDashboard = () => {
  const [selectedImpact, setSelectedImpact] = useState(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPortrait, setIsPortrait] = useState(isMobilePortrait());
  const [hoveredCard, setHoveredCard] = useState(null);

  const theme = useTheme();

  useEffect(() => {
    const handleResize = () => setIsPortrait(isMobilePortrait());
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  const handleViewImpact = (impact) => {
    setSelectedImpact(impact);
    setIsIframeLoaded(false);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedImpact(null);
    setIsIframeLoaded(false);
  };

  const renderCard = (key, title, description, icon, impactKey) => (
    <Col key={key}>
      <div
        onMouseEnter={() => setHoveredCard(key)}
        onMouseLeave={() => setHoveredCard(null)}
        className="impact-card"
        style={{
          width: "100%",
          aspectRatio: "1/2", /* Makes it a perfect square */
          background: theme.palette.background.figma,
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: "12px",
          boxShadow: " 0 4px 10px rgba(96, 33, 243, 0.2)",
          color: theme.palette.primary.main,
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Card
          title={
            <span className="impact-card-title" style={{ color: theme.palette.primary.main, }}>
              {icon} {title}
            </span>
          }
          bordered={false}
          style={{ background: "transparent", boxShadow: "none" }}
        >
          <p className="impact-card-text" style={{ color: theme.palette.primary.main, }}>{description}</p>
          <Button
            variant="contained"
            className="impact-button"
            onClick={() => handleViewImpact(impactKey)}
          >
            View Impact
          </Button>
        </Card>
      </div>
    </Col >
  );

  return (
    <>
      <div className="impact-container" style={{ padding: "24px" }}>
        <Col span={24}>
          <Typography
            variant="h4"
            sx={{
              color: "#000",
              p: 2,
              borderRadius: 2,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Impact
          </Typography>
        </Col>


        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={12} md={8}>
            {renderCard(
              "smartGirl",
              "Smart Girl",
              "Empowering adolescent girls through 1,700+ workshops led by BJS volunteers.",
              <SmileOutlined style={{ color: theme.palette.primary.main }} />,
              "smartGirl"
            )}
            <div style={{ marginTop: 24 }}>
              {renderCard(
                "matrimony",
                "Matrimony",
                "BJS Matrimonial Meets connect Jain youth and families across communities.",
                <TeamOutlined style={{ color: theme.palette.primary.main }} />,
                "matrimony"
              )}
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            {renderCard(
              "healthMission",
              "Health Drives",
              "Organizing regular health camps, screenings, and awareness drives to improve community well-being.",
              <HeartOutlined style={{ color: theme.palette.primary.main }} />,
              "healthMission"
            )}
          </Col>

          <Col xs={24} sm={12} md={8}>
            {renderCard(
              "waterRejuvenation",
              "Water Rejuvenation",
              "Helping communities restore waterbodies through the “RWB” initiative.",
              // <CloudOutlined style={{ color: #1976d2 }} />,
              <CloudOutlined style={{ color: theme.palette.primary.main }} />,
              "waterRejuvenation"
            )}
          </Col>
        </Row>
      </div>

      <Modal
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="100%"
        style={{ top: 0 }}
        bodyStyle={{ padding: 0, height: "100vh" }}
        destroyOnClose
      >
        {isPortrait ? (
          <div className="rotate-message">
            <div style={{ fontSize: 60, marginBottom: 16 }}>
              <RotateLeftOutlined spin />
            </div>
            📱 Please rotate your phone to <strong>landscape</strong> for the
            best experience.
          </div>
        ) : (
          <>
            <div className="iframe-header">{impactTitles[selectedImpact]}</div>

            {!isIframeLoaded && (
              <div className="iframe-loader">
                <Spin size="large" />
              </div>
            )}

            <iframe
              title={impactTitles[selectedImpact]}
              src={powerBIUrls[selectedImpact]}
              style={{
                display: isIframeLoaded ? "block" : "none",
                width: "100%",
                height: "calc(100vh - 50px)",
                border: "none",
              }}
              allowFullScreen
              onLoad={() => setIsIframeLoaded(true)}
            />
          </>
        )}
      </Modal>
    </>
  );
};

export default ImpactDashboard;
